import React from 'react'
import { usePingtaiTypeDelMutation } from '../../../store/DianShangYeWuApi'
import Icon from '../../../cpn/Icon';
import { App } from 'antd'
function ClientDel(props) {
    const {message} = App.useApp()
    const [submitDel] = usePingtaiTypeDelMutation()
    return (
        <Icon type='delete' 
            onClick={() => {
                submitDel({
                    dspt_id:props.dspt_id,
                }).then((res) => {
                    if (res.data.Status === 'success') {
                        message.info('删除成功');
                    }
                    if (res.data.Status === "fail") {
                        message.error('删除失败：'+res.data.Message)
                    }
                })
            }}
        ></Icon>
    )
    }

export default ClientDel